<template>
  <div class="content">
    <div class="content_left">
      <div class="left_top">
        <div class="top_title">学习主页</div>
        <div
          class="top_item"
          :class="index == 'MyCourse' ? 'top_active' : ''"
          @click="choose('MyCourse')"
        >
          <div>我的课程</div>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div
          class="top_item"
          :class="index == 'PaymentRecord' ? 'top_active' : ''"
          @click="choose('PaymentRecord')"
        >
          <div>支付记录</div>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div
          class="top_item"
          :class="index == 'InvoiceApply' ? 'top_active' : ''"
          @click="choose('InvoiceApply')"
        >
          <div>开具发票</div>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div
          class="top_item"
          :class="index == 'Examination' ? 'top_active' : ''"
          @click="choose('Examination')"
        >
          <div>我的考试</div>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div
          class="top_item"
          :class="index == 'MyCertificate' ? 'top_active' : ''"
          @click="choose('MyCertificate')"
        >
          <div>我的证书</div>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div
          class="top_item"
          :class="index == 'SystemMessages' ? 'top_active' : ''"
          @click="choose('SystemMessages')"
        >
          <div>系统消息</div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="left_down">
        <div class="down_title">
          <div>帮助中心</div>
          <div
            style="cursor: pointer"
            :class="index == 'helpCenterPage' ? 'down_active' : ''"
            @click="choose('helpCenterPage')"
          >
            更多<i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <template v-for="(item, index) in helpCenterList_left">
          <div class="down_line"></div>

          <div
            class="down_item"
            style="cursor: pointer"
            @click="goHelpCenterDetail(item)"
          >
            <div></div>
            {{ item.title }}
          </div>
        </template>
      </div>
    </div>
    <div class="content_right">
      <div v-if="index == 'MyCourse'">
        <div class="course_title">学习概况</div>
        <div class="select_right_year">
          年份：
          <el-date-picker
            v-model="selectYear"
            type="year"
            value-format="yyyy"
            size="mini"
            placeholder="选择年"
            @change="getClassList"
          >
          </el-date-picker>
        </div>
        <div class="course_top">
          <div class="flex_align">
            <img
              class="course_headImg"
              v-if="person.coverUrl"
              :src="person.coverUrl"
              @click="imgShow = true"
            />
            <img
              class="course_headImg"
              v-else
              src="../assets/index/head.png"
              @click="imgShow = true"
            />
            <div>
              <div class="course_name">
                {{ userInfo.nick_name }}
                <i class="el-icon-edit" @click="dialogFormVisible = true"></i>
              </div>
              <div class="course_post">岗位：{{ person.roleName }}</div>
            </div>
          </div>
          <div class="course_top_right">
            <div class="flex_align">
              <img class="right_img" src="../assets/personal/price.png" />
              <div>
                <div class="right_top_text">
                  余额
                  <!-- <span>充值</span> -->
                </div>
                <div class="right_down_text">
                  {{ person.balance }}
                </div>
              </div>
            </div>
            <div class="flex_align">
              <img class="right_img" src="../assets/personal/xxsc.png" />
              <div>
                <div class="right_top_text">学习时长</div>
                <div class="right_down_text">
                  {{ formatTime(person.learningTime) }}
                </div>
              </div>
            </div>
            <!-- <div class="flex_align">
							<img class="right_img" src="../assets/personal/xs.png"/>
							<div>
								<div class="right_top_text">
									学时
								</div>
								<div class="right_down_text">
									{{formatTime(person.learnTime)}}
								</div>
							</div>
						</div> -->
            <div class="flex_align">
              <img class="right_img" src="../assets/personal/xf.png" />
              <div>
                <div class="right_top_text">学时</div>
                <div class="right_down_text">
                  {{ person.studyCredit }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="course_title_select">
          我的课程

          <!-- <div class="select_right">
						课程类型：
						<el-select v-model="courseValue" clearable placeholder="请选择" size="mini" @change="getClassList">
							<el-option
								v-for="item in courseOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div> -->
          <div class="select_right">
            课程状态：
            <el-select
              v-model="classValue"
              clearable
              placeholder="请选择"
              size="mini"
              @change="getClassList"
            >
              <el-option
                v-for="item in classOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="course_year">
					<div class="course_year_title">年份:</div>
					<div class="course_year_cont">
						<div class="year_item" :class="selectYear == item?'year_hover':''" v-for="item in yearList" @click="getYear(item)" :key="item">{{ item }}</div>
					</div>
				</div> -->
        <div class="course_type">
          <div class="course_type_title">课程类型:</div>
          <div class="course_type_cont">
            <div
              class="type_item"
              :class="courseValue == item.value ? 'type_hover' : ''"
              v-for="item in courseOptions"
              @click="getType(item)"
              :key="item.value"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
        <div
          class="con_body_div"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <template v-for="(kecheng, kcKey) in classList">
            <div class="item_div" v-if="kecheng.title">
              <div class="item_top">
                <img class="item_img" :src="kecheng.imgUrl" />
              </div>
              <div class="item_title">
                {{ kecheng.title }}
              </div>
              <div class="item_down">
                <div>学时：{{ kecheng.learnTime }}</div>
                <div>
                  进度：{{ kecheng.learnProgress ? kecheng.learnProgress : 0 }}%
                </div>
                <template v-if="kecheng.type == 3">
                  <div
                    class="item_down_btn"
                    style="background: #a9a9a9"
                    @click="goDetail(kecheng)"
                  >
                    已失效
                  </div>
                </template>
                <template v-else>
                  <div class="item_down_btn" @click="goDetail(kecheng)">
                    {{ kecheng.type == 2 ? "再次学习" : "继续学习" }}
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <!--<div class="btm_x"></div>
				<div class="btm_box">
					<div class="btm_left_box">
						<div class="top_bx">公需课程已选择：{{`${leftForm.selecteHours1}/${leftForm.publicCredit}`}}</div>
						<div class="btm_bx">专业课程已选择：{{`${leftForm.selecteHours2}/${leftForm.professionalCredit}`}}</div>
					</div>
					<div class="btm_right_box">
						<div class="btn_left">实付金额：<span style="color: #E55E4B;">￥{{leftForm.fee}}</span></div>
						<!~~ <div :class="getBtntext()=='已过期'?'btn_right_no':'btn_right'">{{ getBtntext() }}</div> ~~>
						<div class="btn_right">支 付</div>
					</div>
				</div>-->
      </div>
      <div v-if="index == 'PaymentRecord'">
        <el-table :data="tableData" key="payment-table" style="width: 100%" :loading="loading">
          <el-table-column
            prop="orderNo"
            label="支付单号"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="courseName"
            label="课程名称"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="courseTypeName"
            label="课程类型"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="payTime"
            label="支付时间"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="payAmount"
            label="支付金额"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="payStatusName"
            label="支付状态"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="refundStatus" label="退费状态" align="center">
            <template slot-scope="scope">
              <!-- 状态为 0：未退款 -->
              <span v-if="scope.row.refundStatus === 0">未退款</span>
              <!-- 状态为 1：退款中 -->
              <span v-else-if="scope.row.refundStatus === 1">退款中</span>
              <!-- 状态为 2：退款成功 -->
              <span v-else-if="scope.row.refundStatus === 2">退款成功</span>
              <!-- 状态为 3：退费失败，带悬浮提示原因 -->
              <el-tooltip
                v-else-if="scope.row.refundStatus === 3"
                :content="scope.row.remarks || '暂无失败原因'"
                placement="bottom"
                effect="light"
              >
                <span class="refund-fail-text">退费失败</span>
              </el-tooltip>
              <!-- 其他未知状态：默认显示退费失败（无提示） -->
              <span v-else>退费失败</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button
                :disabled="
                  scope.row.payAmount == 0 ||
                  scope.row.payAmount == 0.0 ||
                  scope.row.refundStatus == 1 ||
                  scope.row.refundStatus == 2
                "
                @click="requestRefund(scope.row)"
                type="text"
                size="small"
                >申请退费</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenat">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.currentPage"
            :page-sizes="[10, 20, 30, 50]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 开具发票视图 -->
      <div v-if="index == 'InvoiceApply'">
        <div class="course_title_select">
          可开发票订单
          <div class="select_right">
            <el-button 
              type="primary" 
              size="mini" 
              @click="openInvoiceDialog" 
              :disabled="selectedInvoiceOrders.length === 0"
            >
              申请开票 ({{ selectedInvoiceOrders.length }})
            </el-button>
          </div>
        </div>
        
        <el-table 
          :data="invoiceOrderList" 
          key="invoice-table"
          row-key="id"
          style="width: 100%" 
          :loading="loading"
          @selection-change="handleInvoiceSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" reserve-selection></el-table-column>
          <el-table-column prop="orderNo" label="订单号" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="courseName" label="课程名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="payAmount" label="支付金额" align="center">
            <template slot-scope="scope">
              ¥{{ scope.row.payAmount }}
            </template>
          </el-table-column>
          <el-table-column prop="invoiceableAmount" label="可开票金额" align="center">
            <template slot-scope="scope">
              ¥{{ scope.row.invoiceableAmount }}
            </template>
          </el-table-column>
          <el-table-column prop="payTime" label="支付时间" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="invoiceStatus" label="开票状态" align="center">
             <template slot-scope="scope">
               <span v-if="!scope.row.invoiceStatus || scope.row.invoiceStatus === 0">未开票</span>
               <span v-else-if="scope.row.invoiceStatus === 1" style="color: #E6A23C">开票中</span>
               <span v-else-if="scope.row.invoiceStatus === 2" style="color: #67C23A">已开票</span>
               <span v-else-if="scope.row.invoiceStatus === 3" style="color: #F56C6C">开票失败</span>
             </template>
          </el-table-column>
        </el-table>
        
        <div class="pagenat">
          <el-pagination
            @size-change="handleInvoiceSizeChange"
            @current-change="handleInvoiceCurrentChange"
            :current-page="invoicePage.currentPage"
            :page-sizes="[10, 20, 30, 50]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="invoicePage.total"
          >
          </el-pagination>
        </div>
      </div>
      <div v-if="index == 'MyCertificate'">
        <div class="course_title_select">我的证书</div>
        <div
          class="con_body_div"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <template v-for="(certificate, kcKey) in certificateList">
            <div class="item_div">
              <div class="item_top">
                <img
                  class="item_img"
                  :src="toImg(certificate.certificateImg)"
                  @click="toBigImg(certificate.id)"
                />
              </div>
              <div class="item_title">
                {{ certificate.certificateName }}
              </div>
              <div class="item_down">
                <div>{{ certificate.acquireTime }}</div>
                <div class="item_down_btn" @click="goDownload(certificate.id)">
                  下载证书
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="index == 'SystemMessages'">
        <div class="course_title_select" style="margin-top: -0.05rem">
          系统消息
          <div class="select_right">
            类型：
            <el-select
              v-model="messValue"
              clearable
              placeholder="请选择"
              size="mini"
              @change="getMessageList"
            >
              <el-option
                v-for="item in messOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div
          class="con_body_div"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <template v-for="(item, key) in messageList">
            <div
              class="flex_align"
              @click="goMessDetail(item)"
              style="margin-bottom: 0.3rem; cursor: pointer"
            >
              <img class="message_img" src="../assets/personal/message.png" />
              <div class="message_right">
                <div class="message_right_top">
                  {{ item.title }}
                  <span>{{ item.releaseTime }}</span>
                </div>
                <div class="message_right_down">
                  {{ item.content | filtersText }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="index == 'Examination'">
        <div class="course_title_select">我的考试</div>
        <div
          class="con_body_div"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <template v-for="(item, kcKey) in examList">
            <div class="item_div">
              <div class="item_top">
                <img class="item_img" :src="item.imgUrl" />
              </div>
              <div class="item_title">
                {{ item.title }}
              </div>
              <div class="item_down_exm">
                <!-- <div>学时：{{item.learnTime}}</div> -->
                <!-- <div>进度：{{item.learnedNumber | zhuanhuan}}/{{item.countNumber | zhuanhuan}}</div> -->
                <template>
                  <div class="item_down_btn" @click="goExam">考试</div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="index == 'helpCenterPage'">
        <div class="course_title_select" style="margin-top: -0.05rem">
          帮助中心
          <div class="select_right">
            类型：
            <el-select
              v-model="helpCenterValue"
              clearable
              placeholder="请选择"
              size="mini"
              @change="getHelpCenterList"
            >
              <el-option
                v-for="item in helpOptions"
                :key="item.dictValue"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div
          class="con_body_div"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <template v-for="(item, key) in helpCenterList">
            <div
              class="flex_align"
              @click="goHelpCenterDetail(item)"
              style="margin-bottom: 0.3rem; cursor: pointer"
            >
              <img class="help_img" src="../assets/personal/help.png" />
              <div class="help_right">
                <div class="help_right_top">
                  {{ item.title }}
                </div>
                <div class="help_right_down">
                  {{ removeHTMLTags(item.content) }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" width="30%" center>
      <el-form :model="person" label-width="80px">
        <el-form-item label="用户名称">
          <el-input v-model="person.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateName">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="imgShow" width="30%" title="修改头像">
      <div style="text-align: center">
        <el-upload
          class="avatar-uploader"
          :headers="headers"
          action="/api/blade-resource/oss/endpoint/put-file"
          :show-file-list="false"
          accept=".jpg,.png"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="imgShow = false">取 消</el-button>
        <el-button type="primary" @click="getImgUpdate">确 定</el-button>
      </div>
    </el-dialog>
    
    <!-- 申请开票弹窗 -->
    <el-dialog title="申请开具发票" :visible.sync="invoiceDialogVisible" width="500px">
      <el-form :model="invoiceForm" :rules="invoiceRules" ref="invoiceForm" label-width="100px">
        <el-form-item label="发票抬头" prop="title">
          <el-input v-model="invoiceForm.title" placeholder="请输入个人或企业名称"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="taxNo">
          <el-input v-model="invoiceForm.taxNo" placeholder="企业必填，个人可留空"></el-input>
        </el-form-item>
        <el-form-item label="发票类型" prop="type">
          <el-radio-group v-model="invoiceForm.type">
            <el-radio label="1">电子普通发票</el-radio>
            <el-radio label="2">增值税专用发票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="接收邮箱" prop="email">
          <el-input v-model="invoiceForm.email" placeholder="用于接收电子发票文件"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="invoiceForm.remark" placeholder="选填"></el-input>
        </el-form-item>
        
        <div style="margin-top: 10px; color: #909399; font-size: 12px;">
          选中订单数: {{ selectedInvoiceOrders.length }} | 开票金额: ¥{{ totalInvoiceAmount }}
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="invoiceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitInvoiceApply" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
    
    <div
      v-loading="imgLoading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      v-if="isImageExpanded"
      class="expanded-image"
      @click="closeExpandedImage"
    >
      <img :src="expandedImageUrl" class="expanded-img" />
    </div>
    <div
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      v-if="helpCenterConDiv"
      class="expanded-helpConter"
      @click="closeHelpConterCon"
    >
      <div class="content" @click.stop>
        <!-- 新增关闭按钮 -->
        <i class="el-icon-close close-btn" @click="closeHelpConterCon"></i>
        <div class="title">
          <span>{{ helpCenterTitle }}</span>
        </div>
        
        <!-- 包裹内容区域以控制最大高度和滚动 -->
        <div class="del_content_wrapper">
          <div class="del_content" v-html="helpCenterCon"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  name: "personal",
  data() {
    return {
      loading: false,
      loadingText: "加载中",
      index: "MyCourse",
      courseOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "公需课程",
        },
        {
          value: "1",
          label: "专业课程",
        },
      ],
      classOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "未完成",
        },
        {
          value: "2",
          label: "已完成",
        },
        {
          value: "3",
          label: "已过期",
        },
      ],
      messOptions: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "未读",
        },
        {
          value: "2",
          label: "已读",
        },
      ],
      helpOptions: [],
      classValue: "",
      courseValue: "",
      selectYear: "",
      messValue: "0",
      helpCenterValue: "",
      messageList: [],
      helpCenterList: [],
      helpCenterList_left: [],
      classList: [],
      examList: [],
      userInfo: "",
      person: "",
      dialogFormVisible: false,
      certificateList: [],
      isImageExpanded: false,
      expandedImageUrl: "",
      imgLoading: false,
      yearList: [],
      helpCenterConDiv: false,
      helpCenterCon: "",
      helpCenterTitle: "",
      leftForm: {
        selecteHours1: 0, //已选共需课程学时
        selecteHours2: 0, // 已选专业课程学时
        publicCredit: 0, //公需学分
        professionalCredit: 0, //专业学分
        fee: 0, //
      },
      imgShow: false,
      imageUrl: "",
      // 设置上传的请求头部
      headers: {},
      tableData: [],
      // 分页
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 发票相关数据
      invoiceOrderList: [], // 可开票订单列表
      selectedInvoiceOrders: [], // 选中的订单
      invoiceDialogVisible: false, // 开票弹窗显示状态
      submitLoading: false, // 提交加载状态
      invoicePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      invoiceForm: {
        title: '',
        taxNo: '',
        type: '1', // 1:普票, 2:专票
        email: '',
        remark: '',
        orderNos: [] // 存储选中的订单
      },
      invoiceRules: {
        title: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入接收邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        type: [{ required: true, message: '请选择发票类型', trigger: 'change' }]
      }
    };
  },
  computed: {
    // 计算选中订单的总金额
    totalInvoiceAmount() {
      return this.selectedInvoiceOrders.reduce((sum, item) => {
        return sum + (parseFloat(item.invoiceableAmount) || 0);
      }, 0).toFixed(2);
    }
  },
  filters: {
    showData(val, codesMap, dictType) {
      let arrs = codesMap.get(dictType);
      let name = "";
      arrs.forEach((item, index) => {
        if (val == item.code) {
          name = item.name;
          return;
        }
      });
      return name;
    },
    subStringTime(str) {
      return str.substring(0, 10);
    },
    filtersText(val) {
      if (val != null && val != "") {
        val = val.replace(/<[^>]+>/g, "");
        return val;
      } else return "";
    },
    zhuanhuan(val) {
      if (val == "-1") {
        return 0;
      } else {
        return val;
      }
    },
  },
  mounted() {
    //获取登录用户信息
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.getTimeYear();
    this.getPerson();
    if (this.userInfo && this.userInfo.access_token) {
      this.headers = {
        "Blade-Auth": "Bearer " + this.userInfo.access_token,
        // 'JzzbAuthentication': localStorage.getItem('AUTH_TOKEN')
      };
    }
    console.log("this.userInfo", this.userInfo);
    this.getTimeYear();
    this.getPerson();
    this.getHelpCenterType();
  },
  methods: {
    getYear(value) {
      this.selectYear = value;
      this.getClassList();
    },
    getType(row) {
      this.courseValue = row.value;
      this.getClassList();
    },
    getTimeYear() {
      var currentYear = new Date().getFullYear();
      this.yearList = [];
      for (let i = 0; i <= 5; i++) {
        this.yearList.push(JSON.stringify(currentYear - i));
      }
      this.selectYear = this.yearList[0];
      this.getClassList();
    },
    getHelpCenterType() {
      // 查询帮助中心类型
      this.$get("/blade-system/dict/dictionary?code=helpCenter").then((res) => {
        if (res.code == "200") {
          this.helpOptions = res.data;
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
      // 查询最新3条帮助信息
      this.$get("/blade-desk/help/list", {
        current: 1,
        size: 3,
      }).then((res) => {
        if (res.code == "200") {
          this.helpCenterList_left = res.data.records;
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    },
    getBtnLeft() {
      this.$get("/personal-center/v1/personal-subject/credit_hour", {
        year: this.selectYear,
      }).then((res) => {
        if (res.code == "200") {
          this.leftForm = {
            selecteHours1: res.data.selectedCommonCurseHours
              ? res.data.selectedCommonCurseHours
              : 0, //已选共需课程学时
            selecteHours2: res.data.selectedProfessionCurseHours
              ? res.data.selectedProfessionCurseHours
              : 0, // 已选专业课程学时
            publicCredit: res.data.publicCredit ? res.data.publicCredit : 0, //公需学分
            professionalCredit: res.data.professionalCredit
              ? res.data.professionalCredit
              : 0, //专业学分
            fee: res.data.fee ? res.data.fee : 0,
          };
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    },
    // 支付按钮状态判断
    getBtntext() {
      var currentYear = new Date().getFullYear();
      if (this.selectYear == JSON.stringify(currentYear)) {
        return "去支付";
      } else {
        return "已过期";
      }
    },
    getBtnType() {
      if (
        this.leftForm.selecteHours1 >= this.leftForm.publicCredit &&
        this.leftForm.selecteHours2 >= this.leftForm.professionalCredit
      ) {
        return "去支付";
      } else {
        return "已过期";
      }
    },
    formatTime(num) {
      let hour = num / 3600;
      return hour.toFixed(2);
    },
    choose(obj) {
      this.index = obj;
      // 切换页面时清空选中状态
      this.selectedInvoiceOrders = [];
      
      if (this.index == "SystemMessages") {
        this.getMessageList();
      }
      if (this.index == "MyCourse") {
        this.getPerson();
        this.getClassList();
      }
      if (this.index == "PaymentRecord") {
        this.getList();
      }
      if (this.index == "InvoiceApply") {
        this.getInvoiceOrderList();
      }
      if (this.index == "Examination") {
        this.getExam();
      }
      if (this.index == "MyCertificate") {
        this.getCertificateList();
      }
      if (this.index == "helpCenterPage") {
        this.getHelpCenterList();
      }
    },
    // 退费操作
    requestRefund(row) {
      this.$confirm("是否确认申请退费？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          id: row.id,
          refundStatus: 1,
        };
        this.$post("/ordercourserelation/update", params).then((res) => {
          if (res.code == "200") {
            this.$message({
              message: "申请成功，请等待管理员审核",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: res.msg,
            });
          }
        });
      });
    },
    goDetail(obj) {
      let routeUrl = this.$router.resolve({
        path: "/videoDetail/videoDetail",
        query: {
          id: obj.id,
          type: obj.belongType == 0 ? "1" : "2", //1 专题  2 课程
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    //查询概览
    getPerson() {
      this.$get("/personal-center/v1/study-condition", {
        year: this.selectYear,
      }).then((res) => {
        if (res.code == "200") {
          this.person = res.data;
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    },
    //查询我的课程
    getClassList() {
      this.loading = true;
      this.getBtnLeft();
      this.getPerson();
      this.$get("/personal-center/v1/personal-subject/page", {
        current: 1,
        size: 100,
        type: this.classValue,
        year: this.selectYear,
        belongType: this.courseValue,
      })
        .then((res) => {
          if (res.code == "200") {
            this.classList = res.data.records;
            if (this.classList && this.classList.length > 0) {
              this.classList.forEach((item) => {
                if (item.belongType === 0) {
                  let str =
                    item.coverUrl && item.coverUrl.length > 0
                      ? JSON.parse(item.coverUrl)
                      : "";
                  item.imgUrl = str[0].url;
                } else if (item.belongType === 1) {
                  let str =
                    item.coverUrl && item.coverUrl.length > 0
                      ? JSON.parse(item.coverUrl)
                      : "";
                  item.imgUrl = str.link;
                }
              });
            }
          } else {
            this.$message({
              message: res.msg,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    //查询系统消息
    getMessageList() {
      this.loading = true;
      this.$get("/blade-desk/notice/personal", {
        current: 1,
        size: 100,
        category: "1",
        isReadOnly: this.messValue,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == "200") {
            this.messageList = res.data.records;
          } else {
            this.$message({
              message: res.msg,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    goMessDetail(obj) {
      let routeUrl = this.$router.resolve({
        path: "/textDetail/textDetail",
        query: {
          id: obj.id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    //查询帮助中心信息
    getHelpCenterList() {
      this.loading = true;
      this.$get("/blade-desk/help/list", {
        current: 1,
        size: 100,
        problemType: this.helpCenterValue,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == "200") {
            this.helpCenterList = res.data.records;
          } else {
            this.$message({
              message: res.msg,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    goHelpCenterDetail(obj) {
      this.helpCenterConDiv = true;
      this.helpCenterCon = obj.content;
      this.helpCenterTitle = obj.title;
    },
    closeHelpConterCon() {
      this.helpCenterConDiv = false;
    },
    updateName() {
      this.$post("/blade-system/user/update-info", {
        id: this.userInfo.user_id,
        name: this.person.name,
      }).then((res) => {
        // console.log(res);
        if (res.code == "200") {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.getuserInfo();
          this.dialogFormVisible = false;
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    },
    //查询我的考试
    getExam() {
      this.loading = true;
      this.$get("/user/BladeUserCourseSelection/user-exam-page", {})
        .then((res) => {
          // console.log(res, 54544);
          if (res.code == "200") {
            this.examList = res.data.records;
            for (let i = 0; i < this.examList.length; i++) {
              let img = "";
              if (this.classList[i].belongType == 0) {
                img =
                  this.classList[i].coverUrl &&
                  this.classList[i].coverUrl.length > 0
                    ? JSON.parse(this.classList[i].coverUrl)[0].url
                    : "";
              }
              if (this.classList[i].belongType == 1) {
                img =
                  this.classList[i].coverUrl &&
                  this.classList[i].coverUrl.length > 0
                    ? JSON.parse(this.classList[i].coverUrl).link
                    : "";
              }
              this.examList[i].imgUrl = img;
            }
          } else {
            this.$message({
              message: res.msg,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //去考试
    goExam() {
      let routeUrl = this.$router.resolve({
        path: "/examination/examination",
        query: {
          id: obj.id,
          type: "2", //1 专题  2 课程
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    //查询证书
    getCertificateList() {
      this.loading = true;
      this.$get("/blade-resource/certiflcate/list", {
        current: 1,
        size: 100,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == "200") {
            this.certificateList = res.data.records;
          } else {
            this.$message({
              message: res.msg,
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    toImg(val) {
      let url = "data:image/png;base64," + val;
      return url;
    },
    toBigImg(id) {
      this.isImageExpanded = true;
      this.imgLoading = true;
      this.$get("/blade-resource/certiflcate/" + id, {}).then((res) => {
        // console.log(res);
        if (res.code == "200") {
          let url = "data:image/png;base64," + res.data.certificateImg;
          this.expandedImageUrl = url;
          this.imgLoading = false;
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    },
    closeExpandedImage() {
      this.isImageExpanded = false;
      this.expandedImageUrl = "";
    },
    goDownload(id) {
      this.$get("/blade-resource/certiflcate/" + id, {}).then((res) => {
        // console.log(res);
        if (res.code == "200") {
          let url = "data:image/png;base64," + res.data.certificateImg;
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.imageUrl = res.data.link;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 < 500;
      if (!isJPG) {
        this.$message.error("只能上传jpg/png文件");
      }
      if (!isLt2M) {
        this.$message.error("文件大小不能超过500KB");
      }
      return isJPG && isLt2M;
    },
    getImgUpdate() {
      this.$post("blade-system/user/updateAvatar", {
        id: this.userInfo.user_id,
        avatar: this.imageUrl,
      }).then((res) => {
        if (res.code == "200") {
          this.$message({
            message: "修改成功",
            type: "success",
          });

          this.getuserInfo();
          this.getPerson();
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    },
    getuserInfo() {
      this.$get("blade-system/user/info", {
        token: this.userInfo.access_token,
      }).then((res) => {
        if (res.code == 200) {
          this.userInfo.avatar = res.data.avatar;
          this.userInfo.nick_name = res.data.name;
          this.$store.dispatch("userLogin", this.userInfo);
          this.$emit("updateuser", this.userInfo);
          this.imgShow = false;
        }
      });
    },
    removeHTMLTags(text) {
      return text
        .replace(/<[^>]+>/g, "")
        .replace(/\s+/g, "")
        .replace(/&nbsp;/g, "");
    },
    // 分页事件
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 获取支付记录列表
    getList() {
      this.loading = true;
      this.$get("/ordercourserelation/getUserOrderCourse", {
        current: this.page.currentPage,
        size: this.page.pageSize,
      }).then((res) => {
        if (res.code == "200") {
          this.loading = false;
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
          });
        }
      });
    },
    // 获取可开发票订单列表
    getInvoiceOrderList() {
      this.loading = true;
      this.$get('/ordercourserelation/getInvoiceOrderCourse', {
        current: this.invoicePage.currentPage,
        size: this.invoicePage.pageSize,
        invoiceStatus: 0 // 只查询未开票的订单
      }).then((res) => {
        this.loading = false;
        if (res.code == '200') {
          this.invoiceOrderList = res.data.records;
          this.invoicePage.total = res.data.total;
        } else {
          this.$message.error(res.msg || '获取订单列表失败');
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 表格多选变化
    handleInvoiceSelectionChange(val) {
      this.selectedInvoiceOrders = val;
    },
    // 分页大小变化
    handleInvoiceSizeChange(val) {
      this.invoicePage.pageSize = val;
      this.getInvoiceOrderList();
    },
    // 页码变化
    handleInvoiceCurrentChange(val) {
      this.invoicePage.currentPage = val;
      this.getInvoiceOrderList();
    },
    // 打开开票弹窗
    openInvoiceDialog() {
      if (this.selectedInvoiceOrders.length === 0) {
        this.$message.warning('请至少选择一个订单');
        return;
      }
      // 重置表单
      this.invoiceForm = {
        title: '',
        taxNo: '',
        type: '1',
        email: '',
        remark: '',
        orderNos: this.selectedInvoiceOrders.map(item => item.orderNo)
      };
      // 如果有用户邮箱，可以预填充
      if (this.userInfo && this.userInfo.email) {
        this.invoiceForm.email = this.userInfo.email;
      }
      
      this.invoiceDialogVisible = true;
      // 清除之前的校验结果
      this.$nextTick(() => {
        if (this.$refs.invoiceForm) {
          this.$refs.invoiceForm.clearValidate();
        }
      });
    },
    // 提交开票申请
    submitInvoiceApply() {
      this.$refs.invoiceForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          
          // 构造请求参数（直接传递数组，不要转换为字符串）
          const params = {
            orderNos: this.invoiceForm.orderNos,
            title: this.invoiceForm.title,
            taxNo: this.invoiceForm.taxNo,
            type: this.invoiceForm.type,
            email: this.invoiceForm.email,
            remark: this.invoiceForm.remark
          };

          // 调用后台接口申请开票
          this.$post('/blade-pay/invoice-apply/batch-submit', params).then((res) => {
            this.submitLoading = false;
            if (res.code == '200') {
              this.$message.success('开票申请提交成功');
              this.invoiceDialogVisible = false;
              // 刷新列表
              this.getInvoiceOrderList();
              // 清空选中
              this.selectedInvoiceOrders = [];
            } else {
              this.$message.error(res.msg || '开票申请失败');
            }
          }).catch(() => {
            this.submitLoading = false;
          });
        } else {
          return false;
        }
      });
    }
  },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
  width: 2px;
}

/*  滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: rgba(30, 53, 81, 0.4);
}

/*  滚动条上的滚动滑块 */
::-webkit-scrollbar-thumb {
  background-color: rgba(211, 211, 211, 0.7);
  border-radius: 2px;
}
.content {
  background-color: #ebeff1;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  display: flex;
  padding-left: 3.6rem;
  .content_left {
    width: 3.46rem;
    margin-right: 0.2rem;
    .left_top {
      width: 3.46rem;
      height: 4.42rem;
      background: #fff;
      margin-bottom: 0.3rem;
      border-radius: 0.04rem;
      .top_title {
        color: #333333;
        font-family: Alibaba PuHuiTi;
        font-size: 0.2rem;
        padding-top: 0.3rem;
        margin-left: 0.22rem;
        margin-bottom: 0.2rem;
      }
      .top_item {
        width: 2.86rem;
        height: 0.59rem;
        padding: 0 0.3rem;
        color: rgb(0, 0, 0);
        font-family: Alibaba PuHuiTi;
        font-size: 0.18rem;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
      }
      .top_active {
        background: rgba(19, 79, 151, 0.05);
        box-shadow: 0.02rem 0 0 0 #134f97 inset;
      }
    }
    .left_down {
      width: 2.86rem;
      height: 2.13rem;
      background: #fff;
      border-radius: 0.04rem;
      padding: 0.3rem;
      .down_title {
        color: #000000;
        font-family: Alibaba PuHuiTi;
        font-size: 0.2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        div:nth-child(2) {
          color: #a9a9a9;
          font-weight: 400;
        }
      }
      .down_line {
        width: 100%;
        height: 1px;
        background: #eee;
        margin-top: 0.2rem;
      }
      .down_item {
        color: #000000;
        font-family: Alibaba PuHuiTi;
        font-size: 0.16rem;
        font-weight: 400;
        display: flex;
        align-items: center;
        margin-top: 0.2rem;
        div:first-child {
          width: 0.05rem;
          height: 0.05rem;
          background: #134f97;
          border-radius: 50%;
          margin-right: 0.08rem;
        }
      }
    }
  }
  .content_right {
    width: 7.74rem;
    border-radius: 0.04rem;
    background: #fff;
    padding: 0.3rem;
    position: relative;
    .course_title {
      color: rgb(0, 0, 0);
      font-family: Alibaba PuHuiTi;
      font-size: 0.2rem;
      font-weight: 700;
    }
    .select_right_year {
      color: rgb(0, 0, 0);
      font-family: Alibaba PuHuiTi;
      font-size: 0.14rem;
      display: flex;
      align-items: center;
      position: absolute;
      right: 0.2rem;
      top: 0.3rem;
    }
    .course_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.3rem;
      margin-bottom: 0.4rem;
      .course_headImg {
        width: 0.71rem;
        height: 0.71rem;
        border-radius: 50%;
        margin-right: 0.08rem;
        cursor: pointer;
      }
      .course_name {
        color: rgb(0, 0, 0);
        font-family: Alibaba PuHuiTi;
        font-size: 0.16rem;
        margin-bottom: 0.12rem;
        i {
          color: rgba(19, 79, 151, 1);
          cursor: pointer;
        }
      }
      .course_post {
        color: rgb(0, 0, 0);
        font-family: Alibaba PuHuiTi;
        font-size: 0.14rem;
        font-weight: 400;
      }
      .course_top_right {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .right_img {
          width: 0.43rem;
          height: 0.43rem;
          border-radius: 50%;
          margin-right: 0.1rem;
          margin-left: 0.3rem;
        }
        .right_top_text {
          color: rgb(160, 180, 194);
          font-family: Alibaba PuHuiTi;
          font-size: 0.14rem;
          font-weight: 400;
          margin-bottom: 0.06rem;
          span {
            color: rgb(12, 160, 223);
            font-family: Alibaba PuHuiTi;
            font-size: 0.14rem;
            font-weight: 400;
            margin-left: 0.04rem;
          }
        }
        .right_down_text {
          color: rgb(0, 0, 0);
          font-family: Alibaba PuHuiTi;
          font-size: 0.14rem;
        }
      }
    }
    .course_title_select {
      color: rgb(0, 0, 0);
      font-family: Alibaba PuHuiTi;
      font-size: 0.2rem;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.3rem;
      .select_right {
        color: rgb(0, 0, 0);
        font-family: Alibaba PuHuiTi;
        font-size: 0.14rem;
        display: flex;
        align-items: center;
      }
      .el-select {
        width: 90px;
      }
      .el-date-editor {
        width: 90px;
      }
    }
    .course_year {
      display: flex;
      align-items: center;
      .course_year_title {
        color: rgb(0, 0, 0);
        font-family: Alibaba PuHuiTi;
        font-size: 0.16rem;
        font-weight: 400;
        padding-left: 0.1rem;
        border-left: 0.05rem solid #0f81d3;
      }
      .course_year_cont {
        display: flex;
        flex-wrap: wrap;
        .year_item {
          margin-left: 0.2rem;
          width: 0.6rem;
          line-height: 0.25rem;
          color: rgb(0, 0, 0);
          font-family: Alibaba PuHuiTi;
          font-size: 0.16rem;
          font-weight: 400;
          border-radius: 0.05rem;
          text-align: center;
          cursor: pointer;
        }
        .year_hover {
          color: #0f81d3;
          background: #134f971a;
        }
      }
    }
    .course_type {
      display: flex;
      align-items: center;
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
      .course_type_title {
        color: rgb(0, 0, 0);
        font-family: Alibaba PuHuiTi;
        font-size: 0.16rem;
        font-weight: 400;
        padding-left: 0.1rem;
        border-left: 0.05rem solid #0f81d3;
      }
      .course_type_cont {
        display: flex;
        flex-wrap: wrap;
        .type_item {
          margin-left: 0.2rem;
          line-height: 0.25rem;
          color: rgb(0, 0, 0);
          font-family: Alibaba PuHuiTi;
          font-size: 0.16rem;
          font-weight: 400;
          border-radius: 0.05rem;
          text-align: center;
          cursor: pointer;
        }
        .type_hover {
          color: #0f81d3;
          background: #134f971a;
        }
      }
    }
    .message_img {
      width: 0.53rem;
      height: 0.53rem;
      margin-right: 0.08rem;
    }
    .message_right {
      width: 7.16rem;
      .message_right_top {
        color: rgb(0, 0, 0);
        font-family: Alibaba PuHuiTi;
        font-size: 0.16rem;
        margin-bottom: 0.08rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          font-size: 0.14rem;
          font-weight: 400;
        }
      }
      .message_right_down {
        color: #a9a9a9;
        font-family: Alibaba PuHuiTi;
        font-size: 0.14rem;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .help_img {
      width: 0.53rem;
      height: 0.53rem;
      margin-right: 0.08rem;
    }
    .help_right {
      width: 7.16rem;
      .help_right_top {
        color: rgb(0, 0, 0);
        font-family: Alibaba PuHuiTi;
        font-size: 0.16rem;
        margin-bottom: 0.08rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          font-size: 0.14rem;
          font-weight: 400;
        }
      }
      .help_right_down {
        color: #a9a9a9;
        font-family: Alibaba PuHuiTi;
        font-size: 0.14rem;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.flex_align {
  display: flex;
  align-items: center;
}
.con_body_div {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow-y: auto;
  height: 5.14rem;
}
.btm_x {
  width: 100%;
  height: 0.01rem;
  background: #ebeff1;
  margin: 0.2rem 0;
}
.btm_box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 0.6rem;
  position: relative;
  .btm_left_box {
    color: #000000;
    font-family: "Alibaba PuHuiTi";
    font-size: 0.14rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    height: 100%;
    .top_bx {
      margin-bottom: 0.1rem;
    }
  }
  .btm_right_box {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    height: 100%;
    .btn_left {
      color: #000000;
      text-align: right;
      font-family: "Alibaba PuHuiTi";
      font-size: 0.18rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    .btn_right {
      margin-left: 0.3rem;
      width: 1.22rem;
      height: 0.37rem;
      line-height: 0.37rem;
      font-size: 0.16rem;
      font-family: "Alibaba PuHuiTi";
      font-size: 0.16rem;
      font-style: normal;
      font-weight: 500;
      text-align: center;
      border-radius: 0.04rem;
      background: #f5ab3a;
      color: #fff;
      cursor: pointer;
    }
    .btn_right_no {
      margin-left: 0.3rem;
      width: 1.22rem;
      height: 0.37rem;
      line-height: 0.37rem;
      font-size: 0.16rem;
      font-family: "Alibaba PuHuiTi";
      font-size: 0.16rem;
      font-style: normal;
      font-weight: 500;
      text-align: center;
      border-radius: 0.04rem;
      background: #a9a9a9;
      color: #fff;
    }
  }
}
.marginR30 {
  margin-right: 0.3rem;
}
.item_div {
  width: calc((100% - 0.9rem) / 3);
  height: 2.27rem;
  margin-bottom: 0.3rem;
  cursor: pointer;
  margin: 0.15rem;
  .item_top {
    width: 100%;
    height: 1.33rem;
    margin-bottom: 0.08rem;
    .item_img {
      width: 100%;
      height: 1.33rem;
    }
  }
  .item_title {
    color: #000000;
    font-family: Alibaba PuHuiTi;
    font-size: 0.16rem;
    margin-top: 0.08rem;
    margin-bottom: 0.12rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .item_down {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: rgba(169, 169, 169, 1);
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 0.14rem;
    .item_down_btn {
      width: 0.64rem;
      height: 0.26rem;
      border-radius: 0.49rem;
      background: #134f97;
      color: rgb(255, 255, 255);
      font-family: Alibaba PuHuiTi;
      font-size: 0.13rem;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}

.item_down_exm {
  width: 2.38rem;
  display: flex;
  align-items: center;
  justify-content: right;
  color: rgba(169, 169, 169, 1);
  font-family: Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 0.14rem;
  .item_down_btn {
    width: 0.64rem;
    height: 0.26rem;
    border-radius: 0.49rem;
    background: #134f97;
    color: rgb(255, 255, 255);
    font-family: Alibaba PuHuiTi;
    font-size: 0.13rem;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.expanded-image {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.expanded-image img {
  max-width: 80%;
  max-height: 80%;
}
.expanded-helpConter {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  
  .content {
    position: relative; /* 为绝对定位的关闭按钮提供参照 */
    display: flex;
    flex-direction: column; /* 改为列布局，方便控制高度 */
    z-index: 9999;
    white-space: pre-wrap;
    /* overflow: auto; 移除这里的overflow，交给内部wrapper处理 */
    width: 12rem;
    /* max-height: 10rem; 移除这里的高度限制，改为内部控制 */
    background-color: #fff;
    padding: 0.3rem 1.2rem; /* 统一内边距 */
    border-radius: 0.04rem; /* 增加圆角更美观 */
    
    /* 新增关闭按钮样式 */
    .close-btn {
      position: absolute;
      top: 0.15rem;
      right: 0.15rem;
      font-size: 0.24rem;
      color: #909399;
      cursor: pointer;
      transition: color 0.3s;
      
      &:hover {
        color: #ff4040;
      }
    }

    .title {
      width: 100%;
      /* height: 0.1rem; 移除固定高度，让内容自适应 */
      color: #000000;
      font-size: 0.35rem;
      font-family: Alibaba PuHuiTi;
      text-align: center;
      margin-bottom: 0.2rem; /* 增加标题与内容的间距 */
      padding-right: 0.3rem; /* 防止标题文字与关闭按钮重叠 */
    }
    
    /* 新增内容包裹层样式 */
    .del_content_wrapper {
      flex: 1; /* 占据剩余空间 */
      overflow-y: auto; /* 垂直方向自动滚动 */
      max-height: 80vh; /* 最大高度为视口高度的60%，可根据需要调整，例如 8rem */
      padding-right: 0.1rem; /* 给滚动条留点空间 */
      
      /* 自定义滚动条样式（可选，保持与全局一致） */
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(211, 211, 211, 0.7);
        border-radius: 2px;
      }
    }

    .del_content {
      font-size: 0.22rem;
      font-family: Alibaba PuHuiTi;
      color: #000000;
      /* margin-bottom: 0.09rem; 移除，由wrapper控制 */
      /* padding-top: 0.2rem; 移除，由title的margin-bottom控制 */
      /* overflow: auto; 移除，由wrapper控制 */
      line-height: 1.6; /* 增加行高提升阅读体验 */
    }
  }
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.pagenat {
  display: flex;
  justify-content: right;
}
</style>



// WEBPACK FOOTER //
// src/index/personnl.vue